import React from 'react';
import PropTypes from 'prop-types';

const doneActiveStep = (i, importedFileActiveStep) => i < importedFileActiveStep;

const renderDoneImage = () => <img src="/assets/images/check-mark.svg" alt="aaa" />;

const renderStepProcess = (importStepProcess, importedFileActiveStep) => importStepProcess.map((s, i) => {
  const step = (
    <li className={i === importedFileActiveStep ? 'active-step' : ''} key={s.id}>
      <div className="number-and-line">
        <span className={`import-file-step-process-number ${doneActiveStep(i, importedFileActiveStep) ? 'active-step-number-done' : ''}`}>
          { doneActiveStep(i, importedFileActiveStep)
          ? renderDoneImage()
          : i + 1
          }
        </span>
        {i === 0
        ? null
        : <span className={`import-file-step-process-line ${doneActiveStep(i, importedFileActiveStep) ? 'active-step-line-done' : ''}`}>
          <span className={i === importedFileActiveStep ? 'active-step-line' : ''} />
        </span>
        }
      </div>
      <span>{s.stepName}</span>
    </li>
    );
  return step;
});

// const renderStepProcessLine = (importStepProcess, importedFileActiveStep) => importStepProcess.map((s, i) => {
//   const line = (
//     <span key={s.id + s.id} className={i < importedFileActiveStep ? 'import-file-step-process-line active-step-line-done' : 'import-file-step-process-line'}>
//       <span className={i === importedFileActiveStep ? 'active-step-line' : ''} />
//     </span>
//   );
//   return line;
// });

const StepProcess = ({
  importStepProcess,
  importedFileActiveStep,
}) => (
  <div className="import-file-step-process-container">
    <ul className="import-file-step-process">
      {renderStepProcess(importStepProcess, importedFileActiveStep)}
    </ul>
    {/* <div className="import-file-step-process-progress-line">
      {renderStepProcessLine(importStepProcess, importedFileActiveStep)}
    </div> */}
  </div>
);

StepProcess.propTypes = {
  importStepProcess: PropTypes.array,
  makeid: PropTypes.func,
  importedFileActiveStep: PropTypes.number,
};

export default StepProcess;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/stepProcess.js